import { render, staticRenderFns } from "./Salas.vue?vue&type=template&id=694b532f"
import script from "./Salas.vue?vue&type=script&lang=js"
export * from "./Salas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports